<template>
    <div class="container">
        <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
        <div class="basic-bar">
            <div class="title">
                <span>近6月满意度</span>
                <span>({{ currentYear }}年)</span>
                <div id="main" class="bar-chart"></div>
            </div>
        </div>
        <div class="basic-pie">
            <div class="title">
                <span>{{ `${currentMonth}月${currentDate}日` }}</span>
                <span>({{ currentYear }}年)</span>
                <div class="pie-chart">
                    <div class="pie-left">
                        <div class="txt-wrap">
                            <div class="txt">{{ pieInfo.total }}</div>
                            <div class="txt">总满意度</div>
                        </div>
                    </div>
                    <div class="pie-right">
                        <div class="list"><span class="txt">态度：满意度{{ pieInfo.attitude }}</span><img
                                :src="gerArrowStatus(pieInfo.attitudeContrast)" class="arrow"></div>
                        <div class="list"><span class="txt">价格：满意度{{ pieInfo.price }}</span><img
                                :src="gerArrowStatus(pieInfo.priceContrast)" class="arrow"></div>
                        <div class="list"><span class="txt">味道：满意度{{ pieInfo.flavor }}</span><img
                                :src="gerArrowStatus(pieInfo.flavorContrast)" class="arrow"></div>
                        <div class="list"><span class="txt">分量：满意度{{ pieInfo.weight }}</span><img
                                :src="gerArrowStatus(pieInfo.weightContrast)" class="arrow"></div>
                        <div class="list"><span class="txt">卫生：满意度{{ pieInfo.hygiene }}</span><img
                                :src="gerArrowStatus(pieInfo.hygieneContrast)" class="arrow"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts/core';
import { GridComponent } from 'echarts/components';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { zeroFill } from '@/assets/js/common'
import schoolAndDate from "./schoolAndDate.vue";

echarts.use([GridComponent, BarChart, CanvasRenderer]);
export default {
    name: 'chartsPage',
    props: {
        schoolName: {
            type: String,
            default: '',
        },
        dateTime: {
            type: String,
            default: '',
        },
        deptId: {
            type: String,
            default: ''
        },
        infos: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1,
            currentDate: new Date().getDate(),
            arrow_up: require('../assets/images/pie_arrow_up.png'),
            arrow_down: require('../assets/images/pie_arrow_down.png'),
            arrow_not: require('../assets/images/pie_arrow_not.png'),
            pieInfo: {}, // 饼图信息
        }
    },
    components: { schoolAndDate, },
    computed: {},
    created() { },
    mounted() {
        this.initData()
    },
    methods: {
        initData() {
            this.$get(this.$api.getSatisfactionSixMonth, { deptId: this.deptId }).then(res => {
                const currentMonth = new Date().getMonth() + 1
                // 获取最近6个月的月份
                let monthStrArr = []
                for (let i = 1; i <= 6; i++) {
                    const nearMonth = new Date(this.currentYear, currentMonth - i).getMonth() + 1
                    monthStrArr.push(`${nearMonth}月`)
                }

                let barChartDataArr = [0, 0, 0, 0, 0, 0]
                try {
                    barChartDataArr = res.data && res.data.map(item => item.label)
                    this.renderBarChart(monthStrArr.reverse(), barChartDataArr)
                } catch (error) {
                    this.renderBarChart(monthStrArr.reverse(), barChartDataArr)
                }
            })


            this.$get(this.$api.getSatisfactionByDate, {
                queryDate: `${this.currentYear}-${zeroFill(this.currentMonth)}-${zeroFill(this.currentDate)}`,
                deptId: this.deptId
            }).then(res => {
                this.pieInfo = res.data || {}
            }).catch(() => { })
        },

        gerArrowStatus(contrast) {
            switch (contrast) {
                case 'gt':
                    return this.arrow_up
                case 'eq':
                    return this.arrow_not
                case 'lt':
                    return this.arrow_down
                default:
                    return ''
            }
        },

        renderBarChart(optionsData = [], seriesData = []) {
            var chartDom = document.getElementById('main');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    type: 'category',
                    data: optionsData,
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}%'
                    },
                },
                color: {
                    type: 'linear',
                    x: 0, y: 1, x2: 0, y2: 0,
                    colorStops: [{
                        offset: 0, color: '#B0D448'
                    }, {
                        offset: 1, color: '#37C18E'
                    }]
                },
                series: [
                    {
                        data: seriesData,
                        barWidth: 40,
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top',
                            formatter: '{c}%',
                            backgroundColor: 'transparent',
                        },
                    }
                ]
            };

            option && myChart.setOption(option);
        },
    },
}
</script>
<style lang="scss" scoped>
.container {
    background: url('../assets/images/bg_tab4.png') 0 0 no-repeat;
    background-size: 100% 100%;
    position: relative;

    .basic-bar,
    .basic-pie {
        .title {

            >span {
                display: block;
            }

            >span:first-of-type {
                font-weight: bold;
                font-size: vh(28);
                color: #713000;
                padding: vh(20) 0 vh(10);
            }

            >span:nth-of-type(2) {
                font-size: vh(15);
                color: #9A9A99;
            }
        }
    }

    .basic-bar {
        border-bottom: 1px solid #818182;

        .bar-chart {
            width: vh(500);
            height: vh(360);
            margin: auto;
        }
    }

    .basic-pie {
        .pie-chart {
            display: flex;
            justify-content: space-between;
            padding: 0 vh(70) 0 vh(30);
            align-items: center;
            margin-top: vh(30);

            .pie-left {
                width: vh(200);
                height: vh(200);
                border-radius: 50%;
                background: rgba(#00048F, 0.88);
                color: #ffffff;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;

                .txt:nth-of-type(1) {
                    font-size: vh(60);
                }

                .txt:nth-of-type(2) {
                    margin-top: vh(10);
                    font-size: vh(15);
                }
            }

            .pie-right {
                display: flex;
                flex-direction: column;

                .list {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: vh(16);
                    padding-bottom: vh(16);
                    border-bottom: 1px dashed #B9B7AD;

                    &:last-of-type {
                        border-bottom: none;
                    }

                    .txt {
                        font-size: vh(15);
                        font-weight: bold;
                        color: #000000;
                    }

                    .arrow {
                        width: vh(15);
                        margin-left: vh(4);
                    }
                }
            }
        }
    }

}
</style>